// extracted by mini-css-extract-plugin
module.exports = {"iconStyle":"az_kr"};